import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { setBackground, previewBackground } from './actions';
import { reduxKey } from './constants';
const actionHandlers = handleActions({
    [setBackground.toString()]: (state, { payload: { deviationId, backgroundId } })=>_object_spread_props(_object_spread({}, state), {
            [deviationId]: {
                backgroundId
            }
        }),
    [previewBackground.toString()]: (state, { payload: { backgroundId } })=>_object_spread_props(_object_spread({}, state), {
            backgroundPreview: backgroundId
        })
}, {});
export default {
    [reduxKey]: actionHandlers
};
